import {Component, OnInit} from '@angular/core';
import {DialogDefinitionEditorBase} from '@shared/components/platform-tool/platform-tool-dialog-definition/models/dialog-defnition-models';
import {defaultAvatarStyle, defaultRolesId} from '@features/security/security.constants';
import {PlatformCommand} from '@shared/commands/command-base';
import {take} from 'rxjs/operators';
import {CommandService} from '@core/services/command.service';

@Component({
    standalone: false,
    selector: 'app-users-and-roles-with-access',
  templateUrl: './users-and-roles-with-access.component.html',
  styleUrl: './users-and-roles-with-access.component.scss'
})
export class UsersAndRolesWithAccessComponent extends DialogDefinitionEditorBase implements OnInit{
  items = [];
  defaultStyle = defaultAvatarStyle;
  constructor(protected commandService: CommandService) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.init();
    console.log(this.dialogField.editor);
  }

  private init() {
  }

  onRemoveUserOrRole(item: any) {
    if (!this.dialogField.value) {
      this.dialogField.value = [];
    }

    this.dialogField.value = this.dialogField.value.filter(o => o.id !== item.id);
    this.dynamicFormControl.setValue(this.dialogField.value);

    const command = new PlatformCommand('RemoveRoleOrUserPermissionFromDraftSharedDataPointCommand', 'SecurityApi');
    command.fieldValues['UserOrRoleToRemove'] = item.id;
    command.fieldValues['SharedDataPointId'] = this.platformDialog.id;
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe({
      next: (response) => console.log(response),
      error: (err) => console.error(err)
    });
  }

  IsRemoveButtonDisabled(item: any) {
    return item.text?.toLowerCase() === defaultRolesId.Administrator;
  }
}
